import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {ServiceRequestService} from '../../../services/service-request.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import { ServiceRequest, ServiceRequestComment } from '../../../types/data.types';
import {AuthenticationService} from '../../../services/authentication.service';
import { ServiceRequestApiService } from '../../../services/api/service-request-api.service';
import { IVendor } from '../../../types/api-response/building/vendor';
import { IServiceRequestAssign } from '../../../types/api-response/service-request/service-request-assign';
import { IServiceRequestComment } from '../../../types/api-response/service-request/service-request-comment';
import { DirectoryService } from '../../../services/directory.service';
import { IServiceRequestUser } from '../../../types/api-response/service-request/service-request-user';
import {IServiceRequest} from '../../../types/api-response/service-request/service-request';

declare const toastr: any;
declare const swal: any;

enum AssigneeType {
    staff,
    vendor
}

@Component({
    selector: 'service-add-comment-assign-to-modal',
    templateUrl: './service-add-comment-assign-to-modal.component.html',
    styleUrls: ['./service-add-comment-assign-to-modal.component.scss']
})
export class ServiceAddCommentAssignToModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    workers: Array<any> = [];
    staffList: Array<any> = [];
    data: ServiceRequest = new ServiceRequest();
    disabledSubmit = false;
    selectedAssigneeType = AssigneeType.staff;

    assigneeType = AssigneeType;

    selectedVendor: IVendor;

    commentObj: IServiceRequestComment;

    constructor(
        public api: ApiClientService,
        private serviceRequestApi: ServiceRequestApiService,
        public serviceRequestService: ServiceRequestService,
        public authService: AuthenticationService,
        public urlService: UrlService,
        public directoryService: DirectoryService,
    ) {}

    ngOnInit() {
        this.initComment();
        this.initData();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        if (this.serviceRequestService.showAssignToModal) {
            this.getStaffList();
        }
    }

    /**
     * Init comment object
     */
    private initComment() {
        const user: IServiceRequestUser = {
            bdId: this.authService.user.id,
            fullName: this.authService.user.fullName,
            email: this.authService.user.email
        };

        this.commentObj = new ServiceRequestComment(user, !this.authService.userIsResident);
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    if (this.serviceRequestService.showAddCommentModal)
                        this.serviceRequestService.showAddCommentModal = false;
                    else if (this.serviceRequestService.showAssignToModal)
                        this.serviceRequestService.showAssignToModal = false;
                    this.serviceRequestService.serviceRequestInServiceRequestModal = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            if (this.serviceRequestService.showAddCommentModal)
                this.serviceRequestService.showAddCommentModal = false;
            else if (this.serviceRequestService.showAssignToModal)
                this.serviceRequestService.showAssignToModal = false;
            this.serviceRequestService.serviceRequestInServiceRequestModal = null;
            this.urlService.modalClosed.emit();
        }

        this.serviceRequestService.statusForChange = null;
        this.serviceRequestService.isReadStatusForChange = -1;
    }

    vendorChanged(value: IVendor) {
        this.selectedVendor = value;

        let email = '';
        if(value && value.emails.length) {
            email = (value.emails.find(item => item.primary) || value.emails[0]).email;
        }

        this.data.assigneeEmail = email;
    }

    assigneeTypeChange() {
        this.data.assigneeEmail = '';
        this.selectedVendor = null;
        this.commentObj.isPublic = false;
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.assignTo || !this.selectedVendor) {
                toastr.warning('Assign To should not be blank.');
            }

            return;
        }

        this.commentObj.comment = this.commentObj.comment.trim();
        this.commentObj.serviceRequest = this.serviceRequestService.serviceRequestInServiceRequestModal.id;
        this.commentObj.isNotify = !this.serviceRequestService.statusForChange;

        const serviceRequestAssign: Partial<IServiceRequest|IServiceRequestAssign> = {
            emailNotice: true,
            status: this.serviceRequestService.statusForChange,
            isReadComment: this.commentObj.comment || null,
            isRead: this.serviceRequestService.isReadStatusForChange !== -1 ? !!this.serviceRequestService.isReadStatusForChange : null
        };

        let typeRequest = this.serviceRequestApi.updateServiceRequest(this.serviceRequestService.serviceRequestInServiceRequestModal.id, serviceRequestAssign);
        if (this.serviceRequestService.showAssignToModal) {
            if(this.selectedAssigneeType === AssigneeType.staff) {
                if (!form.value.assignTo && !form.value.otherWorker.trim().length) {
                    toastr.warning('Assign To should not be blank.');

                    return;
                }

                const match = this.staffList.find(s => s.id == this.data.serviceRequestWorkerContract);
                serviceRequestAssign.serviceRequestWorkerContractOther = +form.value.assignTo ? match.fullName : form.value.otherWorker;

            } else if(this.assigneeType.vendor) {
                serviceRequestAssign.serviceRequestWorkerContract = {
                    identity: this.selectedVendor.id,
                    name: this.selectedVendor.name
                };
            }

            serviceRequestAssign.assigneeEmail = form.value.assigneeEmail;
            typeRequest = this.serviceRequestApi.assignServiceRequest(this.serviceRequestService.serviceRequestInServiceRequestModal.id, serviceRequestAssign);
        }

        this.disabledSubmit = true;

        typeRequest.subscribe(
            () => {
                if (this.commentObj.comment) {
                    this.serviceRequestApi.addComment(this.commentObj).subscribe(
                        () => toastr.success('Comment was successfully written'),
                        error => this.api.errorHandler(error, 'Comment was not written')
                    );
                }

                this.updateView('Service Request was successfully modified');
            },
            error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Update Service Request failed');
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        if(this.serviceRequestService.statusForChange && this.urlService.queryParams.status &&
           this.urlService.queryParams.status.indexOf(this.serviceRequestService.statusForChange) == -1) {
            this.serviceRequestService.selectedItemData = null;
            this.serviceRequestService.showDetailedView = false;
        }
        this.serviceRequestService.getData();
        this.serviceRequestService.getActivity();
        this.form.reset();
        this.hideModal();
    }

    getStaffList() {
        this.workers = [];
        const url = `/api/users?expand=company,phones&per-page=10000&user_type=property_manager`;
        this.api.get('oauthUrl', url).subscribe(
            res => this.staffList = JSON.parse(res._body).entities || [],
            error => this.api.errorHandler(error, 'Failed get Workers')
        );
    }

    changeAssignee(event) {
        if(event.target.value != '0') {
            const match = this.staffList.find(s => s.id == event.target.value);
            this.data.serviceRequestWorkerContract = event.target.value;
            this.data.assigneeEmail = match ? match.email : '';
        }
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/service-request/service-add-comment-assign-to-modal/service-add-comment-assign-to-modal.component.ts